import React from 'react';
import ProgressBar from '../ProgressBar/ProgressBar';

const JobStatusProgressBar = props => {
  let percentageDone = 0;
  let title = 'Preparing...';
  if (props.completedSteps != null && props.totalSteps != null) {
    percentageDone = ((props.completedSteps / props.totalSteps) * 95).toFixed(1);
    title = props.completedSteps + '/' + props.totalSteps;
    if (props.completedSteps === props.totalSteps) {
      title = 'Finalizing...';
    }
  }
  let jobStatus = '';

  let showProgressBar = false;
  switch (props.jobStatus) {
    case 'RUNNING':
      jobStatus = 'Running';
      showProgressBar = true;
      break;
    case 'PENDING':
      jobStatus = 'Pending';
      break;
    case 'COMPLETED':
      jobStatus = 'Completed';
      break;
    case 'FAILED':
      jobStatus = 'Failed';
      break;
    case 'FAILED_WITH_REPORT':
      jobStatus = 'Failed';
      break;
  }

  if (showProgressBar) {
    switch (props.jobType) {
      case 'IMPORT':
      case 'COPY_DATA':
      case 'PLAN_DEPLOYMENT':
      case 'SCHEDULED_PLAN_DEPLOYMENT':
      case 'DELETE_DATA':
      case 'CLEAR_VALUES':
      case 'SET_DEFAULT':
      case 'QUICK_START':
      case 'QUICK_ASSIGN':
      case 'DELETE_FORECAST':
      case 'DELETE_BUDGET_VERSION':
      case 'CUBE_DEPLOYMENT_FROM_PLAN':
      case 'CUBE_DEPLOYMENT_FROM_MODELER':
        showProgressBar = true;
        break;
      default:
        showProgressBar = false;
        break;
    }
  }

  return showProgressBar ? (
    <div className={'job-status'} title={title}>
      <div className={'job-status-top'}>
        <span className={'job-status-status-text'}>{jobStatus}</span>
        <span className={'job-status-progress-percentage'}>{percentageDone}%</span>
      </div>
      <ProgressBar className={'job-status-progress-bar'} percentageDone={percentageDone} />
    </div>
  ) : (
    <div className={'job-status'}>
      <span className={'job-status-status-text'}>{jobStatus}</span>
    </div>
  );
};

export default JobStatusProgressBar;
